// extracted by mini-css-extract-plugin
export default {"button":"CollapseToggleButton_button__PeTn8","collapsed":"CollapseToggleButton_collapsed__rt-Sm","collapsedLabel":"CollapseToggleButton_collapsedLabel__KYtGG"};